import { Component, OnInit, OnChanges } from '@angular/core';
import { SimpleTravelService } from './simple-travel.service';
import { SimpleTravel } from './product.types';
import { Router, NavigationEnd } from '@angular/router';
import { SharedService } from 'app/shared/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  template: `
    <b4a-product-simple-travel-list [travels]="travels" [clickedNew]="clickedNew.bind(this)"></b4a-product-simple-travel-list>
  `
})
export class SimpleTravelListPageComponent implements OnInit {

  travels: SimpleTravel[];

  constructor(
    private travelService: SimpleTravelService,
    private router: Router,
    private sharedService: SharedService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.sharedService.getUserTravel().subscribe(
      userTravel => {
        if (userTravel === 'basicTravel') {
          this.travelService
          .getBasicTravels()
          .subscribe((data) => {
            console.log(data);
            this.calculatePrices(data)
            this.travels = data;
          },
          err => { console.log(err._body), this.toastr.error('Error occured!') }
        );
        }else {
          this.travelService
          .getSimpleTravels()
          .subscribe((data) => {
            console.log(data);
            this.calculatePrices(data)
            this.travels = data;
          },
          err => this.toastr.error('Error occured!'));
        }
      }
    )
  }

  calculatePrices(data) {
      for (let travel of data ) {
        let temPrice = travel.fromPrice;
        travel.convertedPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(temPrice / 100);
        // tslint:disable-next-line:max-line-length
        if (travel.firstStart !== null) {
          let options = { day: '2-digit', year: 'numeric', month: '2-digit'}
          travel.dateTermin = new Intl.DateTimeFormat('de-DE', options).format(new Date(travel.firstStart))
          + ' - ' + new Intl.DateTimeFormat('de-DE', options).format(new Date(travel.firstEnd))
        }
      }
    }

  public clickedNew() {
    this.router.navigate(['/products/simpleTravel/new']);
  }
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-list-page.container.ts